<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Carriers</h3>
                    <div class="box-tools pull-right">
                        <button
                            :class="isDisabled(isCarriersFetching)"
                            :disabled="isCarriersFetching"
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="emitCarriersClick"
                        >
                            <i
                                :class="changeIcon(collapse)"
                                class="fa"
                            ></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <vue-slide-up-down
                    :active="collapse"
                    :duration="durationCollapse"
                >
                    <div v-if="isCarriersFetching && collapse">
                        <div class="text-center">
                            <img
                                alt="Preloader"
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>
                    </div>
                    <div v-else-if="!isCarriersFetching">
                        <div
                            v-if="!dataLength"
                            class="box-body"
                        >
                            <p>There are no Carriers found.</p>
                        </div>
                        <div
                            v-else
                            class="box-body table-responsive no-padding"
                        >
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th class="text-left">ID</th>
                                        <th class="text-left">Carrier</th>
                                        <th class="text-left">Contacts</th>
                                        <th class="text-left">Messages</th>
                                        <th class="text-left">Clicks</th>
                                        <th class="text-left">Revenues</th>
                                        <th class="text-left">eCPM/EPC</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="carrier in carriers"
                                        :key="carrier.id"
                                    >
                                        <td v-if="carrier.id === 0">
                                            <em class="text-info">None</em>
                                        </td>
                                        <td v-else>{{ carrier.id }}</td>
                                        <td>
                                            <ValueEmpty :value="carrier.name" />
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="carrier.contacts_count"
                                                color="gray"
                                                title="Total"
                                            />
                                            <BadgeTotal
                                                :value="carrier.contacts_active"
                                                color="green"
                                                title="Active"
                                            />
                                            <BadgeTotal
                                                :value="carrier.contacts_inactive"
                                                color="red"
                                                title="Inactive"
                                            />
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="carrier.messages_count"
                                                BadgeTotal
                                                color="gray"
                                                title="Total"
                                            />
                                            <BadgeTotal
                                                :value="carrier.messages_sent"
                                                color="green"
                                                title="Sent"
                                            />
                                            <BadgeTotal
                                                :value="carrier.messages_failed"
                                                color="red"
                                                title="Failed"
                                            />
                                            <BadgeTotal
                                                :value="carrier.messages_blacklisted"
                                                color="black"
                                                title="Blacklisted"
                                            />
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="carrier.percentage + '%'"
                                                color="light-blue"
                                                title="Percentage"
                                            />
                                            <BadgeTotal
                                                :value="carrier.clicks_count"
                                                color="aqua-active"
                                                title="Amount"
                                            />
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="'$' + carrier.revenues_prepared_value"
                                                color="light-blue"
                                                title="Amount"
                                            />
                                            <BadgeTotal
                                                :value="carrier.revenues_count"
                                                color="aqua-active"
                                                title="Count"
                                            />
                                        </td>
                                        <td>
                                            <BadgeTotal
                                                :value="carrier.ecpm_prepared_value"
                                                color="light-blue"
                                                title="eCPM"
                                            />
                                            <BadgeTotal
                                                :value="carrier.epc_prepared_value"
                                                color="aqua-active"
                                                title="EPC"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ValueEmpty from '../../subcomponents/ValueEmpty';
import EventBus from '../../../event-bus';

export default {
    components: {
        ValueEmpty,
        BadgeTotal,
    },

    props: {
        carriers: {
            type: Array,
            default: () => [],
        },

        isCarriersFetching: {
            type: Boolean,
            default: false,
        },

        toggleBtn: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            durationCollapse: 700,
            collapse: this.toggleBtn,
        };
    },

    computed: {
        dataLength: function () {
            return this.carriers.length;
        },
    },
    watch: {
        toggleBtn: function (value) {
            this.collapse = value;
        },
    },
    methods: {
        isDisabled: function (value) {
            return value ? 'disabled-box' : '';
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        emitCarriersClick() {
            this.collapse = !this.toggleBtn;
            EventBus.$emit('clicksCarriers', {
                getCarriers: this.collapse,
            });
        },
    },
};
</script>
